import React from 'react';
import Sidebar from './Sidebar';
import { Bell, User } from 'lucide-react';

const Layout = ({ children }) => {
  return (
    <div className="flex h-screen bg-[#f7f8fa]">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Bar - Shopify Style */}
        <div className="bg-white border-b border-[#e1e3e5] px-6 py-3 flex items-center justify-between">
          <div className="flex-1">
            {/* Breadcrumbs or Page Title can go here */}
          </div>
          <div className="flex items-center gap-4">
            {/* Notifications */}
            <button className="p-2 rounded-lg hover:bg-[#f7f8fa] transition-colors relative">
              <Bell className="w-5 h-5 text-[#6d7175]" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-[#008060] rounded-full"></span>
            </button>
            
            {/* User Profile */}
            <button className="flex items-center gap-2 p-2 rounded-lg hover:bg-[#f7f8fa] transition-colors">
              <div className="w-8 h-8 bg-gradient-to-br from-[#008060] to-[#005e46] rounded-full flex items-center justify-center">
                <User className="w-5 h-5 text-white" />
              </div>
              <span className="text-sm font-medium text-[#202223]">Admin</span>
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-auto bg-[#f7f8fa]">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
